import { HttpClient } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, Input, NgZone, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router, UrlSegment } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { DeviceService } from 'src/app/services/device.service';
import { Error429Service } from 'src/app/services/error429.service';
import { MapService } from 'src/app/services/map.service';
import { environment } from "./../../../../environments/environment";
import { UserDataService } from 'src/app/services/user-data.service';
import { UserService } from 'src/app/services/user.service';
interface Cervezas{
  value: number;
  name: string;
}
interface Clientes{
  value: number;
  name: string;
}
interface Estados{
  value: number;
  name: string;
}
@Component({
  selector: 'app-editar-establecimiento',
  templateUrl: './editar-establecimiento.component.html',
  styleUrls: ['./editar-establecimiento.component.css']
})
export class EditarEstablecimientoComponent{

  lat: number = 43.0081016;
  lng: number = -7.5561412;
  latOriginal: number = 0;
  lngOriginal: number = 0;
  zoom: number = 12;
  searchPlace: string = "";
  addressData: any;
  address: string = "";
  direccionCompleta: string = "";

  etiqueta: string = "";
  identificador: string = "";
  file: File | undefined;
  fileOriginal: File | undefined;
  imageUrl: string | ArrayBuffer | null = null;
  showImageErrorMessage: boolean = false;
  establishmentData: any = []; //Información de los establecimientos y dispositivos
  errorMessage : string =""; //Mensaje de error
  currentPath: string = ""; //Ruta actual
  establecimientoId: number = 0; //Id del dispositivo que está en la ruta
  establecimientoActual: any = []; //Dispositivos que estamos editando
  est_img_path: string = "";
  usuarioEmail: string = "";
  establecimientoDispositivos: any = [];
  numeroDispositivos: number = 0;
  pageSizeOptions: number[] = [5, 10, this.numeroDispositivos];
  showEtiquetaError: boolean = false;
  establecimientoEditado: boolean = false;
  showIdentificadorError: boolean = false;
  waitAfterSave: boolean = false;
  tiempoEsperaRecarga: number = 60000;
  showClienteError: boolean = false;
  telefonoError: boolean = false;
  errorEmail: boolean = false;
  showNoImageError: boolean = false;
  errorFinalMessage: string = "";
  errorFinal: boolean = false;
  noHayImage: boolean = false;

  clientsData: any = [];
  clientes: Clientes[] = [
  ];
  selectedCliente: number | undefined;

  estado: Estados[] = [
    {value: 0, name: 'Desactivado'},
    {value: 1, name: 'Activado'}
  ];
  selectedEstado: number =  1;

  signin: FormGroup = new FormGroup({
    contacto: new FormControl(''),
    telefono: new FormControl(''),
    email: new FormControl('', [Validators.email]),
  });

  dataSource :any;
  displayedColumns: string[] = ['dev_reference', 'dev_label', 'clientId', 'dev_create_at','operaciones'];

  cervezas: Cervezas[] = []
  cervezasControl: FormControl = new FormControl();
  map: any; 
  marker: any;
  userData: any = [];

  //Subscriptions
  private establishmentSubscription: Subscription | undefined;
  private beerTypesSubscription: Subscription | undefined;
  private clientsSubscription: Subscription | undefined;
  
  @ViewChild(MatSort, { static: true }) sort!: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;

  urlBase: string = "";

  constructor(private deviceService: DeviceService, private router: Router, private userDataService: UserDataService,
    private formBuilder: FormBuilder, private userService: UserService, private error429: Error429Service, private toastr: ToastrService,
    private http: HttpClient, private mapService: MapService, private cdr: ChangeDetectorRef){
    this.currentPath = this.router.url;
    this.urlBase = environment.urlNonce;
    this.userData = this.userDataService.getUserData();
  }

  ngOnInit(): void {
    if(this.userData.pro_id != "4"){
      this.displayedColumns = ['dev_reference', 'dev_label', 'dev_create_at','operaciones'];
    }
    //Clientes
    this.clientsSubscription = this.userService.getClients().subscribe({
      next:resp =>{
        for(let i=0; i<resp.length; i++){
          this.clientsData.push(resp[i]);
          this.clientes.push({
            value: resp[i].id,
            name: resp[i].razon_social
          });
        }
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete:()=>{
        //Conseguir el id del establecimiento del path
        this.establecimientoId = this.getDeviceIdFromCurrentPath(this.router);
        //Datos del establecimiento
        this.establishmentSubscription = this.deviceService.getEstablishmentDataNew(this.establecimientoId).subscribe({
          next:resp =>{
            this.establecimientoActual = resp;
          },error:err =>{
            if (err.status == 429) {
              this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
              this.recargarPaginaDespuesDeTiempo();
            } else {
              this.errorMessage = err.error.message;
            }
          },complete: () =>{
            //Tabla de dispositivos
            if (this.establecimientoActual && this.establecimientoActual.devices) {
              for(let i=0; i<this.establecimientoActual.devices.length; i++){
                this.establecimientoDispositivos.push({
                  id: this.establecimientoActual.devices[i].id,
                  dev_reference: this.establecimientoActual.devices[i].dev_reference,
                  dev_label: this.establecimientoActual.devices[i].dev_label,
                  clientId: this.obtenerNombreCliente(this.establecimientoActual.devices[i].dev_cliente_id),
                  dev_create_at: this.establecimientoActual.devices[i].dev_create_at
                });
              }
            }
            this.dataSource = new MatTableDataSource(this.establecimientoDispositivos);
            this.dataSource.filterPredicate = (data: any, filter: string) => {
              const dataStr = this.displayedColumns
                .filter(key => key !== 'id')
                .map(key => data[key])
                .join('')
                .toLowerCase();
          
              return dataStr.includes(filter);
            };
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;

          //Datos del establecimiento
            this.latOriginal = this.establecimientoActual.est_lat;
            this.lngOriginal = this.establecimientoActual.est_lng;
            this.lat = this.establecimientoActual.est_lat;
            this.lng = this.establecimientoActual.est_lng;
            this.signin.setValue({
              contacto: this.establecimientoActual.contacto,
              telefono: this.establecimientoActual.telefono,
              email: this.establecimientoActual.email,
            });
            this.selectedEstado = this.establecimientoActual.status
            this.etiqueta = this.establecimientoActual.est_name;
            this.identificador = this.establecimientoActual.external_id;
            this.selectedCliente = this.establecimientoActual.est_cliente_id;
            let array = JSON.parse(this.establecimientoActual.est_beertypes);
            if (this.establecimientoActual.est_beertypes) {
              this.cervezasControl.setValue(array);
            }
            let est_img = this.establecimientoActual.est_imgs;
            if(this.establecimientoActual.est_imgs != null){
              this.noHayImage = false;
              this.est_img_path = this.urlBase + "/uploads/imgs/"+ est_img;
            } else {
              this.noHayImage = true;
            }
            if(est_img){
              this.noHayImage = true;
              this.showNoImageError = false;
            }
            //Convertir en una variable de tipo file
            /*
            this.http.get(this.est_img_path, { responseType: 'blob' }).subscribe((data: Blob) => {
              this.file = new File([data], 'establecimientoImg.jpg', { type: 'image/jpg' });
              console.log(this.file);
            });
            */
            /*
            fetch(this.est_img_path)
              .then(response => response.blob())
              .then(blob => {
                const file = new File([blob], 'nombre_de_archivo.jpg', { type: 'image/jpg' });
                console.log(file);
              })
            .catch(error => {
              console.error('Error al descargar la imagen:', error);
            })
            */
            /*
            let blob = await fetch(this.est_img_path).then(r => r.blob());
            console.log(blob);
            */
            //Mapa  
            this.mapService.loadMapScript(this.initMap.bind(this));
          }
        });
      }
    });
    //Tipos de cerveza
    this.cervezasControl = this.formBuilder.control([]);
    this.beerTypesSubscription = this.deviceService.getBeerType().subscribe({
      next:resp =>{
        this.cervezas = resp.map((item: any) => ({ value: item.id, name: item.name }));
      }
    });
  }

  initMap(){
    const mapElement = document.getElementById('map');
    // Verificar si el elemento existe antes de intentar trabajar con él
    if (mapElement) {
      const mapOptions = {
        center: { lat: this.lat, lng: this.lng },
        zoom: this.zoom,
      };
      this.map = new google.maps.Map(mapElement, mapOptions);
      this.marker = new google.maps.Marker({
        position: { lat: this.lat, lng: this.lng },
        map: this.map,
        draggable: true,
        title: 'Marcador'
      });
      this.map.addListener('click', (event:any) => {
        this.handleMapClick(event);
      });
      this.marker.addListener('dragend', () => {
        const newPosition = this.marker.getPosition();
        this.lat = newPosition.lat();
        this.lng = newPosition.lng();
        // Actualizar la dirección cuando las coordenadas cambian
        this.getAddress(this.lat, this.lng);
      });
    } else {
      console.error('Elemento del mapa no encontrado en el DOM.');
    }
    this.getAddress(this.lat, this.lng);
    //Cargar los datos cuando se cambia la ubicación en la barra de busqueda
    const inputElement = document.getElementById('pac-input') as HTMLInputElement;
    const autocomplete = new google.maps.places.Autocomplete(inputElement);

    autocomplete.addListener('place_changed', () => {
      const place: google.maps.places.PlaceResult = autocomplete.getPlace();

      if (place.geometry && place.geometry.location) {
        this.lat = place.geometry.location.lat();
        this.lng = place.geometry.location.lng();
        //Cuando se cambia la lat y lng al buscar se vuelve a cambiar el adress
        this.getAddress(this.lat, this.lng);
        this.marker.setPosition({ lat: this.lat, lng: this.lng });
        this.map.setCenter({ lat: this.lat, lng: this.lng });
      } else {
        this.toastr.error("No hay resultados", 'Error', {
          timeOut: 3500,
          progressBar: true,
          titleClass: 'toast-family-font'
        });
      }
    });
  }

  handleMapClick(event: any) {
    // Obtener las coordenadas del clic
    const clickedLat = event.latLng.lat();
    const clickedLng = event.latLng.lng();
    // Actualizar la posición del marcador
    this.lat = clickedLat;
    this.lng = clickedLng;
    this.getAddress(this.lat, this.lng);
    this.marker.setPosition({ lat: clickedLat, lng: clickedLng });
  }

  obtenerNombresDeCervezas(): string {
    const idsSeleccionados = this.cervezasControl.value as number[];
    const nombres: string[] = [];

    if(idsSeleccionados){
      idsSeleccionados.forEach(id => {
        const cervezaEncontrada = this.cervezas.find(cerveza => cerveza.value === id);
        if (cervezaEncontrada) {
          nombres.push(cervezaEncontrada.name);
        }
      });
    }
    return nombres.join(', ');
  }

  obtenerNombreCliente(id: number): string {
    const cliente = this.clientsData.find((cliente:any) => cliente && cliente.id === id);
    return cliente ? cliente.razon_social : 'Cliente no encontrado';
  }

  obtenerNombreEstado(valor: number): string | undefined {
    const estadoEncontrado = this.estado.find(e => e.value === valor);
    return estadoEncontrado ? estadoEncontrado.name : undefined;
  }

  updateEstadoErrorEtiqueta() {
    if (!this.etiqueta) {
        this.showEtiquetaError = true;
    } else {
        this.showEtiquetaError = false;
    }
  }

  updateEstadoErrorCliente() {
    if (this.selectedCliente == undefined) {
        this.showClienteError = true;
    } else {
        this.showClienteError = false;
    }
  }

  ngOnDestroy(): void {
    if (this.establishmentSubscription) {
      this.establishmentSubscription.unsubscribe();
    } 
    if (this.beerTypesSubscription) {
      this.beerTypesSubscription.unsubscribe();
    } 
    if (this.clientsSubscription) {
      this.clientsSubscription.unsubscribe();
    } 
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  //Función para buscar en la tabla
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getDeviceIdFromCurrentPath(router: Router): number {
    const urlTree = router.parseUrl(router.url);
    const segments: UrlSegment[] = urlTree.root.children['primary'].segments;
    // Buscamos el segmento que contiene el número
    let deviceId: number | null = null;
    for (const segment of segments) {
      const value = parseInt(segment.path, 10);
      if (!isNaN(value)) {
        deviceId = value;
        break;
      }
    }
    return deviceId || 0;
  }

  getAddress(latitude: number, longitude: number) {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: {lat: latitude, lng: longitude} }).then((response) => {
      // La posición 0 es el lugar más cercano al click
      if (response.results[0]) {
        this.direccionCompleta = response.results[0].formatted_address;
        const addressComponents = response.results.flatMap(result => result.address_components);
        // Llama a la función para extraer y guardar los valores de los componentes
        this.addressData = this.extractAddressData(addressComponents);
        if (this.addressData.route && this.addressData.street_number) {
          this.address = `${this.addressData.route}, ${this.addressData.street_number}`;
        } else if (this.addressData.route) {
          this.address = this.addressData.route;
        } else if (this.addressData.street_number) {
          this.address = this.addressData.street_number;
        } else {
          this.address = '';
        }
        //console.log('Address Data:', this.addressData);
        this.cdr.detectChanges();
      } else {
        this.toastr.error("No hay resultados", 'Error', {
          timeOut: 3500,
          progressBar: true,
          titleClass: 'toast-family-font'
        });
      }
    });
  }

  // Función para extraer y guardar los valores de los componentes
  extractAddressData(addressComponents: google.maps.GeocoderAddressComponent[]): any {
    const data: any = {};
    for (const component of addressComponents) {
      for (const type of component.types) {
        // Verificar si el tipo ya existe en data y si no, agregarlo
        if (!data[type]) {
          data[type] = component.long_name;
        }
      }
    }
    return data;
  }

  //Cuando se cambia la ubicación en el mapa
  onChoseLocation(event: any){
    this.lat = event.coords.lat;
    this.lng = event.coords.lng;
    this.getAddress(this.lat, this.lng);
  }

  //Cuando se cambian la latitud o longitud manualmente
  updateLocation() {
    this.getAddress(this.lat, this.lng);
  }

  refresh() {
    this.lat = this.latOriginal;
    this.lng = this.lngOriginal
    this.getAddress(this.lat, this.lng);
  }

  onFileSelected(event: any) {
    this.file = event.target.files[0];
    console.log(this.file);
    if (this.file && this.file.type === 'image/jpeg') {
      this.previewImage();
      this.showImageErrorMessage = false;
      this.showNoImageError = false;
    } else {
      this.imageUrl = null;
      this.showImageErrorMessage = true;
    }
    if(this.file == undefined){
      this.showImageErrorMessage = false;
    }
  }

  get contactoInput() { 
    return this.signin.get('contacto'); 
  }
  get telefonoInput() { 
    return this.signin.get('telefono'); 
  }
  get emailInput() { 
    return this.signin.get('email'); 
  }

  clearField(fieldName: string) {
    this.signin.get(fieldName)?.setValue('');
  }

  previewImage() {
    const reader = new FileReader();
    reader.onload = () => {
      this.imageUrl = reader.result;
    };
    reader.readAsDataURL(this.file as Blob);
  }

  get isPhoneNumberValid(): boolean {
    const phoneControl = this.telefonoInput;
    const phoneNumber = phoneControl?.value;
    // Si el número de teléfono está vacío, considerarlo válido
    if (!phoneNumber || phoneNumber.trim() === '') {
      return true;
    }
    const mask = '000 00 00 00'; // Formato utilizado en ngx-mask
    const requiredLength = mask.replace(/[^0]/g, '').length;
    
    return phoneNumber.replace(/[^0-9]/g, '').length === requiredLength;
  }

  getValue(value: string | undefined): string {
    if (value !== undefined) {
      return value;
    }
    return "";
  }

  guardarDispositivo() {
    if (this.identificador == "" || this.identificador == null) {
      this.showIdentificadorError = true;
    } else {
      this.showIdentificadorError = false;
    }
    //Comprobar si falta por añadir una etiqueta
    if (this.etiqueta == "") {
      this.showEtiquetaError = true;
    } else {
      this.showEtiquetaError = false;
    }
    //Comprobar si falta por seleccionar el cliente
    if (this.selectedCliente === undefined) {
      this.showClienteError = true;
    } else {
      this.showClienteError = false;
    }
    //Error teléfono invalido o vacio
    if(this.isPhoneNumberValid){
      this.telefonoError = false;
    } else {
      this.telefonoError = true;
    }
    //No se verifica si el email existe, sino que tenga formato email
    if (this.emailInput?.valid) {
      this.errorEmail = false;
    } else {
      this.errorEmail = true;
    }

    //Editar establecimiento
    if(!this.showEtiquetaError && !this.showClienteError && !this.telefonoError && !this.errorEmail && !this.showNoImageError 
      && !this.showImageErrorMessage && !this.showIdentificadorError){
      const locality = this.addressData.locality ? this.getValue(this.addressData.locality): this.addressData.sublocality
      ? this.getValue(this.addressData.sublocality): this.addressData.sublocality_level_1
        ? this.getValue(this.addressData.sublocality_level_1): '';

      const establecimientoData = new FormData();
      establecimientoData.append('_method', "PATCH");
      establecimientoData.append('id', this.establecimientoId.toString());
      establecimientoData.append('img', this.file as Blob);
      establecimientoData.append('name', this.etiqueta);
      establecimientoData.append('beertypes', JSON.stringify(this.cervezasControl.value));
      establecimientoData.append('contacto', this.contactoInput?.value || '');
      establecimientoData.append('telefono', this.telefonoInput?.value || '');
      establecimientoData.append('email', this.emailInput?.value || '');
      establecimientoData.append('address', this.address);
      establecimientoData.append('localidad', locality);
      establecimientoData.append('provincia', this.getValue(this.addressData.administrative_area_level_2));
      establecimientoData.append('ccaa', this.getValue(this.addressData.administrative_area_level_1));
      establecimientoData.append('pais', this.getValue(this.addressData.country));
      establecimientoData.append('cp', this.getValue(this.addressData.postal_code));
      establecimientoData.append('lat', this.lat.toString());
      establecimientoData.append('lng', this.lng.toString());
      establecimientoData.append('cliente_id', this.selectedCliente?.toString() || '');
      establecimientoData.append('status', this.selectedEstado.toString());
      establecimientoData.append('external_id', this.identificador);

      this.establishmentSubscription = this.deviceService.updateEstablishment(establecimientoData).subscribe({
        next:resp => {
        }, error: err =>{
          console.log(err);
          this.errorMessage = err.error.message;
          console.log(this.errorMessage);
          if(this.errorMessage == undefined){
            this.errorMessage = err.error.error;
            console.log(this.errorMessage);
          }
          if (!this.waitAfterSave) {
            this.waitAfterSave = true;
            this.errorFinal = true;
            setTimeout(() => {
              this.errorFinal = false;
              this.waitAfterSave = false;
            },3500)
          }
        }, complete: () =>{
          if (!this.waitAfterSave) {
            this.waitAfterSave = true;
            this.establecimientoEditado=true;
            setTimeout(() => {
              this.waitAfterSave = false;
              this.establecimientoEditado = false;
            }, 3500);
          }      
        }
      })
    }

    console.log('ID del establecimiento: ', this.establecimientoId);
    console.log('Image', this.file as Blob);
    console.log('Valor de etiqueta: ', this.etiqueta);
    console.log('Tipos de cerveza seleccionados:', this.cervezasControl.value);
    console.log('Contacto: ', this.contactoInput?.value);
    console.log('Teléfono: ', this.telefonoInput?.value);
    console.log('Email: ', this.emailInput?.value);
    console.log('Address: ', this.address);
    console.log('Localidad: ', this.getValue(this.addressData.locality));

    console.log('Latitud = ', this.lat);
    console.log('Longitud = ', this.lng);
    console.log('Cliente: ', this.selectedCliente);
    console.log('Estado: ', this.selectedEstado);

    console.log('---------------------------------------');
  }

}
